<template>
    <div>
        <p class="font-bold" :class="enable ? 'text-black' : 'text-gray-400'">{{title}}</p>
        <button @click.prevent="showSelectStatus = !showSelectStatus" :disabled="!enable" :class="enable ? 'text-black border-gray-500 hover:bg-gray-300 focus:border-gray-300' : 'text-gray-400 bg-[#CDCDCD]'" class="transition-all form-select border rounded-2xl w-full text-left max-h-[42px] mt-1 overflow-hidden overflow-ellipsis whitespace-nowrap">
            {{placeholder}}
        </button>
        <div :class="showSelectStatus ? '' : 'hidden'" class="flex flex-col border border-gray-300 bg-white rounded-2xl mt-2 overflow-auto max-h-[50vh]">
            <label class="flex items-center gap-x-2 p-2 border-t-2 first:border-t-0" v-for="(option) in options" :key="option.id || key">
                <input type="checkbox" :value="option" v-model="value">
                <p>{{option.name || option}}</p>
            </label>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            title: String,
            options: Object,
            enable: {
                type: Boolean,
                default: true
            },
            placeholder: String,
            modelValue: [Object, Array],
        },
        data() {
            return {
                showSelectStatus: false,
            }
        },
        emits: ['update:modelValue'],
        computed: {
            value: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit('update:modelValue', value);
                }
            }
        },
        watch: {
            options: {
                handler(newValue, oldValue) {

                    if(this.selectList?.length > 0) {
                        oldValue.forEach((el, index) => {
                            this.$refs['checkbox-' + index].checked = false
                        })
                    }

                    this.value = [];
                },
                immediate: true,
            },
        },
    }
</script>
